<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">账户</a>
        </li>
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">实名认证</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">企业实名认证</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="th-panel-title">企业实名认证</div>
      </div>
      <div class="panel-body">
        <div class="step-bar-triple step-bar-outer clearfix z-textAlign-center z-margin-bottom-25-precent">
          <div :class="{'step--current':steps === 'first'}" class="step-bar step-bar-begin">
            <div class="step-colored">
							<span>
								① 填写认证资料
							</span>
            </div>
            <span class="step-arrow-right"></span>
          </div>
          <div :class="{'step--current':steps === 'second'}" class="step-bar step-bar-center">
            <span class="step-arrow-left"></span>
            <div class="step-colored">
							<span>
								② 确认认证信息
							</span>
            </div>
            <span class="step-arrow-right"></span>
          </div>
          <div :class="{'step--current':steps === 'three'}" class="step-bar step-bar-end">
            <span class="step-arrow-left"></span>
            <div class="step-colored">
							<span>
								③ 实名认证完成
							</span>
            </div>
            <span class="step-arrow-right"></span>
          </div>
        </div>
        <el-form label-position="right" class="auth-form" :rules="rules" ref="ruleForm" label-width="180px" :model="authForm">
          <el-form-item label="银行开户名：" prop="name">
            <el-input v-model="authForm.C_name" placeholder="请填写营业执照上的公司名称"></el-input>
          </el-form-item>
          <el-form-item label="统一信用代码：" prop="name">
            <el-input v-model="authForm.C_id" placeholder="请填写统一信用代码"></el-input>
          </el-form-item>
          <el-form-item label="开户银行：">
            <el-select v-model="authForm.C_bank" class="blackpink" placeholder="请选择开户行" style="width: 440px;">
              <el-option
                v-for="item in bank"
                :key="item.value"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="银行所在地：">
            <el-select v-model="value1" class="blackpink" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="value2" class="blackpink" placeholder="请选择">
              <el-option
                v-for="item in option"
                :key="item.value"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开户支行名称：">
            <el-input v-model="authForm.C_bank_zhihang" placeholder="请填写开户支行名称"></el-input>
          </el-form-item>
          <el-form-item label="对公银行账号：">
            <el-input v-model="authForm.C_bank_account" placeholder="请务必填写企业对公账户，我们将进行小额打款来进行验证"></el-input>
          </el-form-item>
          <el-form-item label="联系人姓名：">
            <el-input v-model="authForm.C_linkman" placeholder="请输入企业的常用联系人姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系人电话：">
            <el-input v-model="authForm.C_linktel" placeholder="请输入企业的常用联系人电话"></el-input>
          </el-form-item>
          <el-form-item label="联系人QQ：">
            <el-input v-model="authForm.C_qq" placeholder="请输入企业的常用联系人QQ"></el-input>
            <br>
            <p class="z-margin-top-15-precent">我们将对你所填写的账户进行小额打款以完成验证，请在点击下一步前确保所填信息正确有效</p>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="border-radius: 0" @click="submitForm('ruleForm')">下一步</el-button>
            <el-button type="info" plain style="border-radius: 0" @click="back">返回上一步</el-button>
          </el-form-item>
        </el-form>
        <div class="alert-warn-lg clearfix">
          <div class="tip-title">
            温馨提示：
          </div>
          <div class="tips-container">
            <div class="tips-content">
              <div>
                <p>1. 无论是否认证成功系统每次收取1元（测试期0.3元）的认证手续费。因为每次认证系统都会向国家认证中心通过API接口实时查询，此手续费为国家认证中心查询接口的费用。</p>
                <p>2. 请确认企业信息填写正确，对公账户真实有效，请勿使用其他信息进行认证，否则会认证失败</p>
                <p>3. 三丰云会加密保存您的认证资料，绝不会泄露用户隐私，请放心认证</p>
                <p>4. 所填写资料仅用于实名认证，不会开通其他任何附加服务，三丰云工作人员不会向您索要短信验证码，谨防上当</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import { MessageBox } from 'element-ui';
  import userService from 'business/userService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import area from 'utils/tongxun.js'
  export default {
    data () {
      return {
        dialogLoading:false,
        steps:'first',
        cert_state:Number,
        authForm:{
          C_name:'',
          C_id:'',
          C_bank:'',
          C_bank_zhihang:'',
          C_bank_addr:'',
          C_bank_account:'',
          C_linktel:'',
          C_qq:'',
          C_linkman:'',
        },
        bank:[
          {value: '请选择开户银行'},
          {value: '中国工商银行'},
          {value: '中国银行'},
          {value: '招商银行'},
          {value: '中国建设银行'},
          {value: '中国农业银行'},
          {value: '中信银行'},
          {value: '中国民生银行'},
          {value: '交通银行'},
          {value: '中国光大银行'},
          {value: '深圳发展银行'},
          {value: '平安银行'},
          {value: '农村信用合作社'},
          {value: '中国邮政储蓄银行'},
          {value: '广东发展银行'},
          {value: '广发银行'},
          {value: '上海浦东发展银行'},
          {value: '上海银行'},
          {value: '北京银行'},
          {value: '兴业银行'},
          {value: '北京农村商业银行'},
          {value: '城市信用合作社'},
          {value: '福建兴业银行'},
          {value: '广东南粤银行'},
          {value: '广州农村商业银行'},
          {value: '广州银行'},
          {value: '桂林银行'},
          {value: '杭州联合银行'},
          {value: '杭州银行'},
          {value: '恒丰银行'},
          {value: '华夏银行'},
          {value: '徽商银行'},
          {value: '宁波银行'},
          {value: '农村合作银行'},
          {value: '农村商业银行'},
          {value: '上海农村商业银行'},
          {value: '新韩银行'},
          {value: '渣打银行'},
          {value: '浙商银行'},
          {value: '中国进出口银行'},
          {value: '中国农业发展银行'},
          {value: '重庆三峡银行'},
          {value: '城市商业银行'},
          {value: '村镇银行'},
          {value: '富滇银行'},
          {value: '汉口银行'},
          {value: '国家开发银行'},
          {value: '东亚银行'},
          {value: '渤海银行'},
          {value: '三井住友银行'},
          {value: '其他'}
        ],
        options: area,
        option: [],
        C_bank: '',
        value1: '',
        value2: '',
        rules: {
          name: [

          ],
        }
      }
    },
    components:{
      XdialogLoading,
    },
    props:{
      hide:Boolean
    },
    watch:{
      value1(val){
        this.option = this.options.filter(items => {
          return items.value === val
        })[0].sub
        this.value2 = this.option[0].value
      }
    },
    mounted() {
      this.getState()
    },
    methods:{
      async getState() {
        let data = 'cmd=smrz_info'
        let {vueData, state} = await userService.transformToVue('smrzInfo','POST',data)
        if(vueData.response == 200 ) {
          this.cert_state = vueData.cert_state
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      async submitForm() {
        MessageBox.confirm('该操作将从您的帐户中扣除0.3元的认证费用,确定要提交吗?', '确认', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          lockScroll: false,
          type: 'warning'
        }).then(async() => {
          let data = 'cmd=smrz_c'+
            '&C_name='+ this.authForm.C_name +
            '&C_id='+ this.authForm.C_id +
            '&C_bank='+ this.authForm.C_bank +
            '&C_bank_zhihang='+ this.authForm.C_bank_zhihang +
            '&C_bank_addr='+ this.value1 + this.value2 +
            '&C_bank_account='+ this.authForm.C_bank_account +
            '&C_linktel='+ this.authForm.C_linktel +
            '&C_qq='+ this.authForm.C_qq +
            '&C_linkman='+ this.authForm.C_linkman
          this.dialogLoading = true
          let {vueData, state} = await userService.transformToVue('smrzInfo','POST',data)
          if(vueData.response == 200 ) {
            this.dialogLoading = false
            let self = this
            this.$dialog({type:'success', info: vueData.msg, click () {
                self.$router.push('/auth')
              }})
          }else {
            this.dialogLoading = false
            this.$dialog({type:'error', info: vueData.msg, click () {}})
          }
        }).catch(() => {

        });
      },
      back(){
        this.$router.push('/auth')
      },
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .auth-form .el-input {
    width: 440px;
  }
  .step-bar {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    position: relative;
    float: left;
    width: 33%;
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    color: #fff;
  }
  /* 父容器添加，变为3或4或5个步骤，triple是3,quadra是4，penta是5*/
  .step-bar-triple .step-bar {
    width: 33.3%;
  }
  .step-bar-quadra .step-bar {
    width: 25%;
  }
  .step-bar-penta .step-bar {
    width: 20%;
  }
  .step-bar-begin {
    padding-right: 18px;
  }
  .step-bar-center {
    padding: 0 18px;
  }
  .step-bar-end {
    padding-left: 18px;
  }
  .step-colored {
    background-color: #7fddff;
  }
  /*.step-prefix {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: -16px;
  }
  .step--current .step-prefix {
    background: url(img/uc/step_complete.png) no-repeat center;
    vertical-align: middle;
    !* 字体隐藏，由于模板中控制text-hide类比较复杂，这里使用step--current统一控制样式*!
    border: 0;
    background-color: transparent;
    color: transparent;
    font: 0/0 a;
    text-shadow: none;
  }
  .step--current.step--failed .step-prefix {
    background-image: url(img/uc/step_failed.png);
  }
  .step--current.step--dealing .step-prefix {
    background-image: url(img/uc/step_waiting.png);
  }*/
  .step--current .step-colored {
    background-color: #00aaff;
    color: #fff;
  }
  .step--completed .step-colored {
    background-color: #7fddff;
    color: #fff;
  }
  .step-arrow-left,
  .step-arrow-right {
    position: absolute;
    top: 0;
    border: 18px solid transparent;
    border-left-color: #7fddff;
  }
  .step-arrow-left {
    left: -8px;
    border: 18px solid #7fddff;
    border-left-color: transparent;
  }
  .step-arrow-right {
    right: -18px;
  }
  .step--current .step-arrow-left {
    border-color: #00aaff;
    border-left-color: transparent;
  }
  .step--current .step-arrow-right {
    border-left-color: #00aaff;
  }
  /* 对当前步骤之后的所有步骤设置灰色样式 */
  .step--current ~ .step-bar .step-colored {
    background-color: #f2f2f2;
    color: #636566;
  }
  .step--current ~ .step-bar .step-arrow-left {
    border-color: #f2f2f2;
    border-left-color: transparent;
  }
  .step--current ~ .step-bar .step-arrow-right {
    border-left-color: #f2f2f2;
  }
  .alert-warn-lg .tip-title {
    margin-top: 10px;
    position: relative;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    padding-left: 10px;
    font-weight: bold;
    color: #ff6600;
    font-size: 14px;
  }
  .alert-warn-lg .tip-title:after {
    position: absolute;
    bottom: -1px;
    left: 0;
    content: "";
    width: 80px;
    height: 2px;
    background: #ff6600;
  }
  .tips-container {
    float: left;
  }
  .tips-content {
    padding-top: 20px;
    font-size: 12px;
    color: #636566;
  }
  .tips-content > div {
    overflow: hidden;
  }
  .tips-content p {
    margin: 0 0 15px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/user/enterpriseAuth.vue